import React from 'react'
import { Carousel as ReactResponsiveCarousel } from 'react-responsive-carousel'

export interface CarouselProps {
    /**
     * The classname -- this is mostly used to hook GA event tracking
     */
    className?: string
    showIndicators?: boolean
    showStatus?: boolean
    renderThumbs?: () => any
    dynamicHeight?: boolean
    centerMode?: boolean
    centerSlidePercentage?: number
    infiniteLoop?: boolean
    useKeyboardArrows?: boolean
    emulateTouch?: boolean
    children: React.ReactElement | React.ReactElement[]
}

export function Carousel(props: CarouselProps) {
    const {
        showIndicators = false,
        showStatus = false,
        className = '',
        dynamicHeight = false,
        infiniteLoop = false,
        useKeyboardArrows = true,
        emulateTouch = true,
        renderThumbs,
    } = props

    if (!Array.isArray(props.children)) {
        props.children = [props.children]
    }
    return (
        <ReactResponsiveCarousel
            showIndicators={showIndicators}
            showStatus={showStatus}
            showThumbs={props.children.length > 1}
            thumbWidth={64}
            className={className + ' js_Carousel'}
            dynamicHeight={dynamicHeight}
            infiniteLoop={infiniteLoop}
            useKeyboardArrows={useKeyboardArrows}
            emulateTouch={emulateTouch}
            renderThumbs={renderThumbs}
            /**
             * We are not allowing this prop to be changed. Instead, we are using CSS to control the arrow buttons.
             */
            showArrows={true}
            {...props}
        >
            {props.children}
        </ReactResponsiveCarousel>
    )
}
